import {
  Tooltip,
  TooltipContent,
  TooltipTrigger,
} from "@/components/ui/tooltip";
import { useTranslation } from "@/hooks/useTranslation";
import { cn } from "@/lib/utils";
import { Minus, Plus } from "lucide-react";

interface ProLicenseCountSelectorProps {
  value: number;
  min?: number;
  onValueChange: (value: number) => void;
  disabled?: boolean;
  className?: string;
}

export const LicenseCountSelector = ({
  value,
  min = 1,
  onValueChange,
  disabled = false,
  className = "",
}: ProLicenseCountSelectorProps) => {
  const { t } = useTranslation();

  const handleDecrement = () => {
    const newValue = Math.max(value - 1, min);
    onValueChange(newValue);
  };

  const handleIncrement = () => {
    onValueChange(value + 1);
  };

  const isDecrementDisabled = disabled || value <= min;

  return (
    <div className={cn(`flex items-center gap-2`, className)}>
      <Tooltip>
        <TooltipTrigger asChild>
          <button
            type="button"
            onClick={handleDecrement}
            disabled={isDecrementDisabled}
            className="flex items-center justify-center w-8 h-8 transition-colors border rounded border-input bg-card hover:bg-secondary dark:hover:bg-secondary disabled:opacity-50 disabled:cursor-not-allowed"
          >
            <Minus className="w-4 h-4" />
          </button>
        </TooltipTrigger>
        {isDecrementDisabled && min > 1 && (
          <TooltipContent>
            <p>
              {t("setup.paymentMethod.plan.price.licenseTooltip", {
                count: min,
              })}
            </p>
          </TooltipContent>
        )}
      </Tooltip>

      <input
        type="number"
        min={min}
        value={value}
        readOnly
        inputMode="none"
        className="w-16 px-2 py-1 font-bold text-center border rounded cursor-not-allowed bg-secondary border-input text-foreground"
      />

      <button
        type="button"
        onClick={handleIncrement}
        disabled={disabled}
        className="flex items-center justify-center w-8 h-8 transition-colors border rounded border-input bg-card hover:bg-secondary dark:hover:bg-secondary disabled:opacity-50 disabled:cursor-not-allowed"
      >
        <Plus className="w-4 h-4" />
      </button>
    </div>
  );
};
